import Button from 'modules/shared-components/button/button';

export default function MarketplaceCardLoading() {
  return (
    <div className="flex flex-col group bg-transparent min-h-[95px] md:min-h-[329px] bg-strategy-card-dark hover:bg-strategy-card-dark-raised shadow-lg hover:shadow-lg hover:shadow-base transition-shadow xxs:rounded-lg">
      <div className="md:bg-black-700 group-hover:bg-black-600  xxs:px-3 rounded-t-lg xxs:pt-3 xxs:pb-6">
        <div className="flex items-start">
          <div className="xxs:flex items-center xxs:gap-1">
            <div className="clip-mizar-hexagon h-[50px] w-[50px] bg-black-300 dark:bg-black-500" />
            <div className="overflow-hidden  xxs:flex-grow max-w-[120px]">
              <div className="space-y-1">
                <div className="h-3 w-16 bg-black-300 dark:bg-black-500 rounded" />
                <div className="h-2 w-8 bg-black-300 dark:bg-black-500 rounded" />
              </div>
            </div>
            <div className="h-2 bg-black-300 dark:bg-black-500 rounded col-span-2" />
          </div>
        </div>
      </div>
      <div className="hidden md:block xxs:p-2 grow justify-end flex flex-col xxs:pb-8">
        <div className="animate-pulse space-x-4">
          <div className="space-y-2 py-1">
            <div className="space-y-1">
              <div className="h-3 w-16 bg-black-300 dark:bg-black-500 rounded" />
              <div className="h-2 w-8 bg-black-300 dark:bg-black-500 rounded" />
            </div>
            <Button variant="neutral" className="w-full py-2">
              <div className="h-3 w-16 bg-black-300 dark:bg-black-500 rounded" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
